import { AppConfig } from "./appConfig";

export default function configLoader(): Promise<AppConfig> {

    const envModule = (() => {

      if (import.meta.env.VITE_ENV_MODE === "dev") {
      // local with full auth
      return import(/* webpackChunkName: "environment" */ "./config.dev.json");
    }
    // prod build
    return import(/* webpackChunkName: "environment" */ "./config.token.json");
  })();

  return envModule.then((c) => c.default);
}
